<template>
  <div class="skeleton-main">
    <div class="item" v-for="opt in options.moduleCount" :key="opt" :style="`backgroundColor: ${backgroundColor};borderRadius: ${!isEditor ? 0 : '5px'};marginBottom: ${!isEditor ? 0 : '12px'}`">
      <div
        class="item-line"
        :class="[
          item === 1 ? 'w-20' : '',
          item === 2 ? 'w-50' : '',
          item === 5 ? 'w-30' : '',
          item === 2 ? 'margin-t-36' : 'margin-t-20',
          !isEditor ? 'animation' : ''
        ]"
        v-for="item in options.count"
        :key="item"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Skeleton',
  props: {
    options: {
      type: Object,
      default() {
        return {
          count: 5, // 每个模块多少个横条
          moduleCount: 4
        };
      }
    },
    // 背景色
    backgroundColor: {
      type: String,
      default: "#fff"
    },
    isEditor: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="scss" scope>
  .skeleton-main {
    box-sizing: border-box;
    width: 100%;
    & * {
      box-sizing: border-box;
    }
    .margin-t-20 {
      margin-top: 20px;
    }
    .margin-t-36 {
      margin-top: 36px;
    }
    .w-20 { width: 20%; }
    .w-30 { width: 30%; }
    .w-40 { width: 40%; }
    .w-50 { width: 50%; }
    .w-60 { width: 60%; }
    .w-70 { width: 70%; }
    .item {
      width: 100%;
      background: #fff;
      padding: 32px;
      .item-line {
        height: 14px;
        background: #F2F2F2;
        &:first-child {
          margin-top: 0;
        }
      }
      .animation {
        background-size: 400% 100%;
        background-image: -webkit-gradient(linear, 0% 0%, 100% 0%, color-stop(0.25, rgb(242, 242, 242)), color-stop(0.37, rgb(230, 230, 230)), color-stop(0.63, rgb(242, 242, 242)));
        background-image: gradient(linear, 0% 0%, 100% 0%, color-stop(0.25, rgb(242, 242, 242)), color-stop(0.37, rgb(230, 230, 230)), color-stop(0.63, rgb(242, 242, 242)));
        animation: ant-skeleton-loading 1.4s ease infinite;
      @keyframes ant-skeleton-loading{0%{background-position:100% 50%}100%{background-position:0 50%}}
      }
    }
  }
</style>